import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';
import sidebarStyles from '@/components/investigador/sidebar/sidebar.module.css';
import styles from './BackToDirectoryButton.module.css';

/**
 * Volver al directorio, desde la ficha de una persona y sólo en el teléfono.
 *
 * En pantallas angostas la barra superior muestra únicamente dónde estás —menú,
 * icono y título—: el atrás no entraba sin dejar el nombre recortado. Acá sí
 * tiene lugar, y además queda a la altura de compartir, que es donde el ojo ya
 * está cuando termina de leer la ficha, en vez de en la esquina opuesta.
 *
 * Apunta al directorio y no al historial: quien llega desde un buscador no tiene
 * a dónde volver, y un botón que a veces saca del sitio no sirve de salida.
 */
export function BackToDirectoryButton() {
	return (
		<Link
			href="/investigadores"
			className={`${sidebarStyles.btnGhost} ${styles.backButton}`}
			aria-label="Volver al directorio"
		>
			<ArrowLeft size={14} aria-hidden="true" />
			Volver
		</Link>
	);
}
